import { useEffect } from 'react'

import { queryClient } from '@queries/query-client'

import { stayTimelineQueryKeys } from '../queries/queryKeys'
import { TIMELINE_HIDDEN_GRACE_MS } from '../StayTimeline.consts'

interface UseRefreshTimelineOnVisibleParams {
  bookingId?: string
  isEnabled: boolean
}

export const useRefreshTimelineOnVisible = ({
  bookingId,
  isEnabled,
}: UseRefreshTimelineOnVisibleParams) => {
  useEffect(() => {
    if (!bookingId || !isEnabled) return

    let hiddenAt = document.visibilityState === 'hidden' ? Date.now() : undefined

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        hiddenAt = Date.now()
        return
      }

      const wasAwayLong =
        hiddenAt !== undefined && Date.now() - hiddenAt >= TIMELINE_HIDDEN_GRACE_MS

      hiddenAt = undefined

      if (!wasAwayLong) return

      void queryClient.invalidateQueries({
        queryKey: stayTimelineQueryKeys.bookingConversations(bookingId),
      })
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [bookingId, isEnabled])
}
